"use client";

import RouteError from "@/components/RouteError";

export default function Error(props: { error: Error & { digest?: string }; reset: () => void }) {
  return (
    <RouteError
      {...props}
      boundary="ai_astrologer_route"
      message="We could not load the AI astrologer. Please try again."
    />
  );
}
